import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CustomForm from '../Form';
import './styles.css';
import {
  Grid,
  Button,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useStyles } from './styles';
import useWindowSize from '../../customHooks/useWindowSize';
import { useHistory } from 'react-router-dom';
import ErrorMessages from './ErrorMessages';
import { AlertDialog } from '../UI/AlertDialog';
import { useTranslation } from 'react-i18next';

const TemplateWithGrid = (props) => {
  const {
    schemas,
    uiSchemas,
    handleChange,
    handleChangeForm,
    handleClickSubmit,
    expanded,
    errors,
    formData
  } = props;

  const [deleteTemplateDialog, setDeleteTemplateDialog] = useState(false);

  const classes = useStyles();
  const windowSize = useWindowSize();
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <>
      <ErrorMessages errors={errors} />
      <Grid
        container
        direction='row'
        justify={windowSize.width >= 1440 ? 'center' : 'flex-start'}
      >
        <Grid item xs={12} lg={9} xl={8}>
          <Typography variant='h5' className={classes.title}>
            {t('templateWithGrid:header')}
          </Typography>

          <div className={classes.root}>
            {schemas.map((objSchema, index) => {
              return (
                <Accordion
                  key={`${index}_${objSchema.name}`}
                  expanded={expanded === objSchema.name}
                  onChange={handleChange(objSchema.name)}
                  classes={{
                    root: classes.expansionPanel
                  }}
                  square
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    className={classes.expansionPanelSummary}
                  >
                    <Typography variant='subtitle1'>
                      {objSchema.name}
                    </Typography>
                    {objSchema.message ? (
                      <div className={classes.column}>
                        <Typography className={classes.secondaryHeading}>
                          {t('templateWithGrid:mandatoryFields')}
                        </Typography>
                      </div>
                    ) : (
                      <div className={classes.column} />
                    )}
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <div style={{ width: '87.5%' }}>
                      <CustomForm
                        className='Template'
                        formData={formData}
                        schema={objSchema.schema}
                        uiSchema={{
                          [objSchema.name]: uiSchemas[objSchema.name]
                        }}
                        id={`${index}_${objSchema.name}`}
                        onChange={handleChangeForm(objSchema.name)}
                      />
                    </div>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </div>
        </Grid>
      </Grid>
      <Grid
        container
        direction='row'
        justify='flex-start'
        style={{ marginTop: 65 }}
      >
        <Grid
          item
          xs={2}
          style={{
            display: windowSize.width >= 1440 ? 'flex' : 'none'
          }}
        />
        <Grid
          container
          item
          xs={6}
          lg={4}
          xl={3}
          style={{ marginBottom: 60 }}
        >
          <Button
            size='medium'
            color='primary'
            onClick={() => setDeleteTemplateDialog(true)}
            style={{ marginRight: 32 }}
          >
            {t('templateWithGrid:cancel')}
          </Button>
          <Button
            color='primary'
            type='submit'
            variant='contained'
            onClick={handleClickSubmit}
          >
            {t('templateWithGrid:capSave')}
          </Button>
        </Grid>
      </Grid>
      {deleteTemplateDialog &&
        <AlertDialog
          description={t('templateWithGrid:deleteMessage')}
          callbackFunc={() => history.push('/template')}
          open={deleteTemplateDialog}
          setOpen={setDeleteTemplateDialog}
        />}
    </>
  );
};

TemplateWithGrid.propTypes = {
  schemas: PropTypes.array.isRequired,
  uiSchemas: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleChangeForm: PropTypes.func.isRequired,
  handleClickSubmit: PropTypes.func.isRequired,
  expanded: PropTypes.string,
  errors: PropTypes.array.isRequired,
  formData: PropTypes.object.isRequired
};

export default TemplateWithGrid;
